import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { paymentActions } from "../redux/paymentSlice";
import { invoiceActions } from "../redux/invoiceSlice";
import api from "../utils/api";
import { Button, Skeleton } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { SlArrowLeft } from "react-icons/sl";
import { DownloadOutlined, FileImageOutlined } from "@ant-design/icons";
import SyncLoader from "react-spinners/SyncLoader";

const Payment = () => {
  const [isInvoice, setIsInvoice] = useState(true);
  const dispatch = useDispatch();

  const {
    invoices,
    loading: invoiceLoading,
    error: invoiceError,
  } = useSelector((state) => state.invoices);

  const {
    payments,
    loading: paymentLoading,
    error: paymentError,
  } = useSelector((state) => state.payments);
  console.log("inv", payments);

  useEffect(() => {
    if (isInvoice) {
      // Fetch invoice data
      dispatch(invoiceActions.getInvoices());
    } else {
      // Fetch payment data
      dispatch(paymentActions.getPayments());
    }
  }, [isInvoice, dispatch]);

  const handleInvoiceClick = () => {
    setIsInvoice(true);
  };

  const handlePaymentClick = () => {
    setIsInvoice(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Confirmed":
        return "text-green-500"; // Green for Completed
      case "Pending":
        return "text-yellow-500"; // Yellow for Pending
      case "Rejected":
        return "text-red-500"; // Red for Rejected
      default:
        return "gray-300"; // Default color
    }
  };

  return (
    <>
      <div className="flex justify-between bg-[#3F3F95] px-4 py-2 w-full rounded-b-lg mb-4">
        <div className="items-center my-auto">
          <Link to="/userdash">
            <SlArrowLeft className="text-white" />
          </Link>
        </div>
        <h3 className="font-bold flex justify-center mx-auto text-[22px] text-white">
          Invoice and Payment List
        </h3>
      </div>
      <div className="flex justify-between mb-8">
        {" "}
        <button
          className="font-bold flex justify-center flex-col mx-auto text-[22px] text-black"
          onClick={handleInvoiceClick}
        >
          Invoice List
          {isInvoice && <span className="bg-[#403F93] h-1 w-32"></span>}
        </button>
        <button
          className="font-bold flex justify-center flex-col mx-auto text-[22px] text-black"
          onClick={handlePaymentClick}
        >
          Payment List
          {!isInvoice && <span className="bg-[#403F93] h-1 w-32"></span>}
        </button>
      </div>
      {invoiceLoading || paymentLoading ? (
        <div className="flex justify-center mt-8 align-middle items-center">
          <SyncLoader
            color="#3F3F95"
            loading={invoiceLoading || paymentLoading}
            size={15}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-4 mt-4 mx-4">
            {isInvoice &&
              invoices?.data?.map((invoice) => (
                <Link
                  to={`/invoice-detail/${invoice.id}`}
                  key={invoice.id}
                  className="flex flex-col border border-gray-300 bg-white p-4 rounded-lg shadow-md"
                >
                  <div className="">
                    <p className="text-sm">
                      Date {new Date(invoice.created_at).toLocaleDateString()}
                    </p>
                    <p className="text-sm">
                      Invoice for month:{" "}
                      <span className="">{invoice.month}</span>
                    </p>
                  </div>
                  <div className="h-[1px] w-full bg-gray-600" />
                  <div className="my-2">
                    {invoice.invoice_items.map((item) => (
                      <div className="flex justify-between text-sm my-1">
                        <p>{item.particular}</p>
                        <p>Rs. {item.total}</p>
                      </div>
                    ))}
                  </div>
                  <div className="h-[1px] w-full bg-gray-600 " />
                  <div className="flex justify-between text-sm">
                    <p className="">Total</p>
                    <p className="">{invoice.total_amount}</p>
                  </div>
                  <div className="mt-4">
                    <Button
                      className="bg-[#19891A] text-md text-white w-full text-center"
                      icon={<DownloadOutlined />}
                      style={{
                        padding: "10px 0px",
                      }}
                    >
                      Download invoice
                    </Button>
                  </div>
                </Link>
              ))}

            {!isInvoice &&
              payments.map((payment) => (
                <Link
                  to={`/payment-detail/${payment.id}`}
                  key={payment.id}
                  className="flex flex-col border border-gray-300 bg-white p-4 rounded-lg shadow-md text-sm"
                >
                  <div className="flex justify-between">
                    <p>Id</p>
                    <p>{payment.id}</p>
                  </div>
                  <div className="flex justify-between">
                    <p>Date</p>
                    <p>{payment.date}</p>
                  </div>
                  <div className="flex justify-between">
                    <p>Paid Amount</p>
                    <p>{payment.amount}</p>
                  </div>
                  <div className="h-[1px] w-full bg-gray-600" />
                  <div className="flex justify-between">
                    <p className="">Status</p>
                    <p className={`${getStatusColor(payment.status)}`}>
                      {payment?.status}
                    </p>
                  </div>
                  {payment.status === "Rejected" && (
                    <div className="">
                      <p className="">Rejected reason</p>
                      <p className="">{payment?.rejected_reason}</p>
                    </div>
                  )}
                  {payment.status === "Pending" && (
                    <div className="mt-4">
                      <Link to={`/editpayment/${payment.id}`}>
                        <Button
                          className="bg-[#19891A] text-md text-white w-full text-center"
                          style={{
                            padding: "10px 0px",
                          }}
                        >
                          Edit payment
                        </Button>
                      </Link>
                    </div>
                  )}
                </Link>
              ))}
          </div>
        </>
      )}
    </>
  );
};

export default Payment;
